// extracted by mini-css-extract-plugin
export var divider = "_nf-0";
export var systemMessage = "_nf-1";